const { v4: uuid } = require('uuid');

/**
 * @property {string} displayMessage -
 *    The message which, if it is present, should be displayed to the user
 *    if the client is showing a modal error message.
 *    The message has been translated into either the user's requested language
 *    or into the "default" language if the language request by the user
 *    is not available.
 */
class AppError extends Error {

  constructor({
    id = uuid(),
    message,
    code,
    httpStatusCode = 500,
    details,
    originalError,
    dynamicValues = {},
    displayMessage = undefined,
    displayTitle = undefined,
  } = {}) {
    super(message);

    this.id = id;
    this.code = code;
    this.httpStatusCode = httpStatusCode;
    this.details = details;
    this.originalError = originalError;
    this.displayMessage = displayMessage;
    this.displayTitle = displayTitle;
    this.dynamicValues = dynamicValues;

    this.name = this.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this._appendOriginalErrorStack();
  }

  _appendOriginalErrorStack() {
    if (!this.originalError) {
      return;
    }
    this.stack = `${this.stack}\n${this.originalError.stack}`;
  }

  toString() {
    let result = super.toString();
    if (this.originalError) {
      result += `. ${this.originalError.toString()}`;
    }

    let metadata = '';
    if (this.code) {
      metadata += `Code: [${this.code}] `;
    }

    metadata += `ErrorID: [${this.id}]`;

    return `${result}. ${metadata}`;
  }

  toJSON() {
    return {
      id: this.id,
      message: this.message,
      details: this.details || '',
      code: this.code,
      httpStatusCode: this.httpStatusCode,
      ...(this.displayMessage && { displayMessage: this.displayMessage }),
      ...(this.displayTitle && { displayTitle: this.displayTitle }),
    };
  }

  setDisplayMessage(displayMessage) {
    this.displayMessage = displayMessage;
  }

  setDisplayTitle(displayTitle) {
    this.displayTitle = displayTitle;
  }
}

module.exports = {
  AppError,
};
